import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Clock, MessageCircle, Instagram, Globe, Navigation, Calendar } from 'lucide-react';
export function Contact() {
  const whatsappUrl = 'https://wa.me/5493417453398?text=Hola%2C+quiero+consultar+por+El+Matambrito+🍖';
  return <section id="contacto" className="py-24 bg-matambrito-black relative" data-id="element-114">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-115">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-116">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-matambrito-cream mb-4" data-id="element-117">
            ¿Venís esta noche?{' '}
            <span className="text-matambrito-gold" data-id="element-118">Reservá tu lugar</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-matambrito-beige font-light" data-id="element-119">
            Estamos para responder tus consultas, tomar tu reserva o contarte
            qué hay esta semana.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-120">
          {/* Left Column - Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-8" data-id="element-121">
            <div className="bg-matambrito-charcoal rounded-2xl p-8 border border-white/5 space-y-6" data-id="element-122">
              <div className="flex items-start gap-4" data-id="element-123">
                <div className="bg-matambrito-red-dark/20 p-3 rounded-lg text-matambrito-red-fire mt-1" data-id="element-124">
                  <MapPin className="w-6 h-6" data-id="element-125" />
                </div>
                <div data-id="element-126">
                  <h4 className="text-matambrito-cream font-medium mb-1" data-id="element-127">
                    Dirección
                  </h4>
                  <p className="text-matambrito-beige/80" data-id="element-128">
                    Av. San Martín 2666
                    <br data-id="element-129" />
                    Villa Gobernador Gálvez, Santa Fe
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-130">
                <div className="bg-matambrito-gold/10 p-3 rounded-lg text-matambrito-gold mt-1" data-id="element-131">
                  <Clock className="w-6 h-6" data-id="element-132" />
                </div>
                <div data-id="element-133">
                  <h4 className="text-matambrito-cream font-medium mb-1" data-id="element-134">
                    Horarios
                  </h4>
                  <p className="text-matambrito-beige/80" data-id="element-135">
                    <strong className="text-matambrito-beige" data-id="element-136">Mediodía:</strong>{' '}
                    Martes a Domingo — 11:00 a 16:00hs
                    <br data-id="element-137" />
                    <strong className="text-matambrito-beige" data-id="element-138">
                      Noche:
                    </strong>{' '}
                    Lunes a Domingo — 19:00 a 01:00hs
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-139">
                <div className="bg-[#25D366]/10 p-3 rounded-lg text-[#25D366] mt-1" data-id="element-140">
                  <MessageCircle className="w-6 h-6" data-id="element-141" />
                </div>
                <div data-id="element-142">
                  <h4 className="text-matambrito-cream font-medium mb-1" data-id="element-143">
                    WhatsApp
                  </h4>
                  <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="text-matambrito-beige/80 hover:text-[#25D366] transition-colors" data-id="element-144">
                    341-7453398
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-145">
                <div className="bg-white/5 p-3 rounded-lg text-matambrito-cream mt-1" data-id="element-146">
                  <Instagram className="w-6 h-6" data-id="element-147" />
                </div>
                <div data-id="element-148">
                  <h4 className="text-matambrito-cream font-medium mb-1" data-id="element-149">
                    Redes Sociales
                  </h4>
                  <div className="flex flex-col gap-1" data-id="element-150">
                    <a href="https://instagram.com/elmatambritovgg" target="_blank" rel="noopener noreferrer" className="text-matambrito-beige/80 hover:text-matambrito-cream transition-colors" data-id="element-151">
                      @elmatambritovgg (Sede Principal)
                    </a>
                    <a href="https://instagram.com/coffe_allegra" target="_blank" rel="noopener noreferrer" className="text-matambrito-beige/80 hover:text-matambrito-cream transition-colors" data-id="element-152">
                      @coffe_allegra (Allegra Café)
                    </a>
                  </div>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-153">
                <div className="bg-white/5 p-3 rounded-lg text-matambrito-cream mt-1" data-id="element-154">
                  <Globe className="w-6 h-6" data-id="element-155" />
                </div>
                <div data-id="element-156">
                  <h4 className="text-matambrito-cream font-medium mb-1" data-id="element-157">
                    Sitio Web
                  </h4>
                  <a href="https://elmatambrito.com" target="_blank" rel="noopener noreferrer" className="text-matambrito-beige/80 hover:text-matambrito-cream transition-colors" data-id="element-158">
                    elmatambrito.com
                  </a>
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-4" data-id="element-159">
              <a href="https://maps.google.com/?q=Av.+San+Martín+2666,+Villa+Gobernador+Gálvez,+Santa+Fe" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-3 w-full bg-white/10 hover:bg-white/20 text-matambrito-cream px-6 py-4 rounded-lg font-medium transition-colors text-lg" data-id="element-160">
                <Navigation className="w-6 h-6" data-id="element-161" />
                Cómo Llegar
              </a>
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-3 w-full bg-[#25D366]/20 text-[#25D366] hover:bg-[#25D366] hover:text-white border border-[#25D366]/50 px-6 py-4 rounded-lg font-medium transition-colors text-lg" data-id="element-162">
                <MessageCircle className="w-6 h-6" data-id="element-163" />
                Hablar por WhatsApp
              </a>
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-3 w-full bg-matambrito-red-fire hover:bg-matambrito-red-dark text-white px-6 py-4 rounded-lg font-medium transition-colors text-lg shadow-lg shadow-matambrito-red-fire/20" data-id="element-164">
                <Calendar className="w-6 h-6" data-id="element-165" />
                Reservar Mesa
              </a>
            </div>
          </motion.div>

          {/* Right Column - Map */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="h-full min-h-[400px] rounded-2xl overflow-hidden border border-white/10 shadow-2xl" data-id="element-166">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3345.542289659089!2d-60.635833!3d-33.015!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95b7ab0000000000%3A0x0!2sAv.%20San%20Mart%C3%ADn%202666%2C%20Villa%20Gobernador%20G%C3%A1lvez%2C%20Santa%20Fe!5e0!3m2!1ses-419!2sar!4v1700000000000!5m2!1ses-419!2sar" width="100%" height="100%" style={{
            border: 0,
            filter: 'invert(90%) hue-rotate(180deg) brightness(80%) contrast(120%)'
          }} allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Mapa de ubicación El Matambrito" data-id="element-167"></iframe>
          </motion.div>
        </div>
      </div>
    </section>;
}